<template>
    <sa-page-layout ref="pgaView" :btnBackVisible="true" :btnEditVisible="true" :titolo="gruppo.nome" :linkback="linkback" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-row>
                <b-col cols="12" md="2" class="sa-text-right">Nome:</b-col>
                <b-col cols="12" md="4">
                    <b>{{ gruppo.nome }}</b>
                </b-col>
                <b-col cols="12" md="2" class="sa-text-right">Descrizione:</b-col>
                <b-col cols="12" md="4">
                    <b>{{ gruppo.descrizione }}</b>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <div class="sa-config-menu-tab">
                <ul class="sa-config-menu">
                    <template v-for="voceMenu in gruppoVociMenu">
                        <li :class="getClassMainManu(voceMenu)" :key="voceMenu.routeId" v-if="isSelect(voceMenu)">
                            <span class="sa-config-menu-li-span">
                                <span :class="voceMenu.children.length !== 0 ? 'sa-config-menu-li-icon sa-config-menu-pointer' : 'sa-config-menu-li-icon'"><i :class="'fas fa-' + voceMenu.iconCls"></i></span>
                                <p>
                                    <span :class="voceMenu.children.length !== 0 ? 'sa-config-menu-li-label sa-config-menu-pointer' : 'sa-config-menu-li-label'">{{ voceMenu.text }}</span>
                                </p>
                                <span class="sa-config-menu-submenu-li-check-icon">
                                    <i class="bi bi-check-lg"></i>
                                </span>
                            </span>
                            <ul class="sa-config-menu-submenu">
                                <template v-for="subitem in voceMenu.children">
                                    <li :key="subitem.routeId" class="sa-config-menu-submenu-li" v-if="subitem.selezionato">
                                        <span>
                                            <span class="sa-config-menu-submenu-li-icon"><i :class="'fas fa-' + subitem.iconCls"></i></span>
                                            <p>
                                                <span class="sa-config-menu-submenu-li-label">{{ subitem.text }}</span>
                                            </p>
                                            <span class="sa-config-menu-submenu-li-check-icon">
                                                <i class="bi bi-check-lg"></i>
                                            </span>
                                        </span>
                                    </li>
                                </template>
                            </ul>
                        </li>
                    </template>
                </ul>
            </div>
        </template>
    </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
//import { SaModalLoading } from "../../../components/modal";
export default {
    components: { SaPageLayout },
    data() {
        return {
            gruppo: { nome: "", descrizione: "", menu: [], sezioni: [] },
            linkback: "/configurazionepazientimenu",
            linkedit: null,
            showModalLoading: false,
            vociMenu: [],
            gruppoVociMenu: [],
            menu: [],
            gruppoMenu: [],
        };
    },
    mounted: function () {
        let me = this;
        me.showModalLoading = true;
        me.linkedit = "/configurazionepazientimenu/edit/" + me.$route.params.id;
        me.loadData(me.$route.params.id);
    },
    methods: {
        isSelect(item) {
            return item.selezionato;
        },
        loadData(id) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/pazientemenu/all";
            axios.get(link).then((response) => {
                me.menu = response.data.data;
                link = process.env.VUE_APP_PATH_API + "/pazientemenu/gruppo";
                axios
                    .get(link, {
                        params: {
                            gruppoId: id,
                        },
                    })
                    .then((response) => {
                        me.gruppoMenu = response.data.data;
                        let routeIdGruppo = new Set(me.gruppoMenu.map((item) => item.vociMenurouteId));
                        me.vociMenu = me.menu
                            .filter((voce) => routeIdGruppo.has(voce.routeId))
                            .map((voce) => ({
                                ...voce,
                                children: [],
                                selezionato: true,
                            }));
                        link = process.env.VUE_APP_PATH_API + "/gruppi/";
                        axios.get(link + id).then((response) => {
                            me.gruppo = response.data.data;
                        });
                        me.raggruppaVociMenu([null, "-"]);
                    });
                me.showModalLoading = false;
            });
        },
        raggruppaVociMenu(idPadri) {
            let me = this;
            me.vociMenu.forEach((element) => {
                if (idPadri.includes(element.idPadre)) {
                    element.children = [];
                    me.setMenuChildren(element);
                    me.gruppoVociMenu.push(element);
                }
            });
        },
        setMenuChildren(voceMenu) {
            let me = this;
            me.vociMenu.forEach((element) => {
                if (element.idPadre === voceMenu.routeId) {
                    element.children = [];
                    voceMenu.children.push(element);
                }
            });
        },
        getClassMainManu(voceMenu) {
            let returnValue = "sa-config-menu-li";
            voceMenu.children.forEach((element) => {
                if (element.selezionato) {
                    returnValue = "sa-config-menu-li sa-config-menu-li-open";
                }
            });
            return returnValue;
        },
    },
};
</script>
<style>
.sa-text-right {
    text-align: right;
}
@media only screen and (max-width: 767px) {
    .sa-text-right {
        text-align: left;
    }
}
.card {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2);
    margin-bottom: 1rem;
}
.sa-config-menu-submenu-li-check-icon {
    width: 42px;
    font-size: 1.6rem;
    text-align: center;
    padding-top: 5px;
    padding-left: 15px;
    color: green;
}
</style>
